import type { ButtonProps } from "@components/ngg";
import { Button as NGGButton } from "@components/ngg";

export default function Button<C extends React.ElementType = "button">({
  children,
  ...props
}: ButtonProps<C>) {
  return (
    <NGGButton className="btn-primary" {...(props as any)}>
      {children}
    </NGGButton>
  );
}
